var map = {
	"./banners/amostras_medicamentos_bg.webp": "b10c",
	"./banners/documentos_digitais_bg.webp": "af27",
	"./banners/faturas_bg.webp": "976a",
	"./banners/hub_solucoes.webp": "d67c",
	"./banners/repositorio_unico_bg.webp": "749b",
	"./banners/representantes-farmaceuticos-digitais-o-futuro-da-industria-baixe-o-ebook.webp": "a872",
	"./banners/video_interativo_bg.webp": "d1fe",
	"./bg-about.webp": "3d69",
	"./bg-contato.webp": "a8cc",
	"./bg-frase.webp": "11c8",
	"./bg-header-default.webp": "3a82",
	"./bg-numbers.webp": "ebe3",
	"./logo-datacoress-simbolo.webp": "edb8"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "d4ab";